import { formatIceServers } from 'features/sdk/utils/formatIceServers';
import { RTCClient } from 'utils/webrtc';
import type { SignalingInitData } from 'features/application/types';

export const generateConnectionParams = (initData: SignalingInitData) => ({
  mediaServer: {
    url: initData.mediaServers.publishing.url,
    token: initData.mediaServers.publishing.token,
  },
  iceServers: formatIceServers(initData.iceServers),
  iceRelay: initData.iceRelay,
  room: {
    id: RTCClient.roomId,
    pin: RTCClient.roomPin,
  },
});
